'use client';

import * as React from 'react';
import { Button, CircularProgress, Typography } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { LearningPathByIdEventKeys, LearningPathByIdEvents } from '../../events';
import { useLearningPathByIdStore } from '../../store/learning-path-by-id-store';
import { EventBus } from '@/shared/utils';

const AddToFavourites: React.FC<{
  eventBus: EventBus<LearningPathByIdEvents>;
  learningPathDocumentId: string;
}> = ({ eventBus, learningPathDocumentId }) => {
  const { favouriteLearningPath } = useLearningPathByIdStore();

  React.useEffect(() => {
    if (favouriteLearningPath === null && !!learningPathDocumentId) {
      eventBus.emit(LearningPathByIdEventKeys.favourites.view, {
        learningPathDocumentId: learningPathDocumentId,
      });
    }
  }, [favouriteLearningPath?.isFavourite, eventBus, learningPathDocumentId]);

  const handleAddToFavourite = (
    isFavourite: boolean,
    favouriteDocumentId: string | null | undefined,
  ) => {
    if (isFavourite && favouriteDocumentId) {
      eventBus.emit(LearningPathByIdEventKeys.favourites.delete, { favouriteDocumentId });
      return;
    }
    eventBus.emit(LearningPathByIdEventKeys.favourites.create, {
      learningPathDocumentId: learningPathDocumentId,
    });
  };

  return (
    <Button
      onClick={() =>
        handleAddToFavourite(
          !!favouriteLearningPath?.isFavourite,
          favouriteLearningPath?.documentId,
        )
      }
      size="large"
      variant="outlined"
      color="primary"
      className={`w-full gap-2 ${favouriteLearningPath?.isLoading ? 'pointer-events-none opacity-80' : ''}`} // "pointer-events-none" to disable user interactions when button is loading
      disabled={favouriteLearningPath?.isLoading || !favouriteLearningPath}
    >
      {favouriteLearningPath?.isLoading ? (
        <CircularProgress size={24} color="inherit" />
      ) : favouriteLearningPath?.isFavourite ? (
        <FavoriteIcon color="primary" />
      ) : (
        <FavoriteBorderIcon />
      )}
      <Typography variant="button-l">
        {favouriteLearningPath?.isFavourite
          ? 'Aggiunto ai preferiti'
          : favouriteLearningPath?.isLoading
            ? 'In elaborazione...'
            : 'Aggiungi a preferiti'}
      </Typography>
    </Button>
  );
};

export { AddToFavourites };
